import type { ButtressDbService } from '@buttress/crag';

const FIRST_RETRY_MS = 1_000;
const MAX_RETRY_MS = 30_000;

export function retryDelay(attempt: number): number {
  return Math.min(MAX_RETRY_MS, FIRST_RETRY_MS * 2 ** (attempt - 1));
}

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export async function connectWithRetry(
  db: Pick<ButtressDbService, 'connect'>,
  onFailure: (err: unknown, attempt: number) => void,
  wait: (ms: number) => Promise<void> = sleep,
): Promise<void> {
  for (let attempt = 1; ; attempt += 1) {
    try {
      await db.connect();
      return;
    } catch (err) {
      onFailure(err, attempt);
      await wait(retryDelay(attempt));
    }
  }
}

// crag rejects every waiter when a connect fails; keep waiting for the next attempt, as crag 0.0.x did.
export async function awaitDbConnection(db: Pick<ButtressDbService, 'awaitConnection'>): Promise<void> {
  let connected = false;
  while (!connected) {
    connected = await db.awaitConnection().catch(() => false);
  }
}
